var module; UMD(module, {
  "minted:m": ["M"],
})(this, function (m_module) {
  const enums = {
    apps: {
      'Cu3': 'Cu3',
      'OldPdp': 'OldPdp',
      'OldCategory': 'OldCategory'
    },
    components: {
      'LeftSidebar': 'LeftSidebar',
      'RightSidebar': 'RightSidebar',
      'MainContent': 'MainContent',
      'Promo': 'Promo',
      'Filters': 'Filters',
    }
  };

  const M = m_module.M;
  M.MintedAnalytics = M.MintedAnalytics || {};
  M.MintedAnalytics.enums = M.MintedAnalytics.enums || enums;

  return enums;
});
